<template>
	<div class="white" style="color: black">
		<v-container fluid style="max-width: 1200px">
			<div class="d-md-flex ba block w-100 mb-1">
				<div style="flex: 1" class="br">
					<v-img
						eager
						contain
						class="mx-auto"
						max-width="200"
						max-height="130"
						src="@/assets/lusazu_logo.png"
						lazy-src="@/assets/lusazu_logo.png"
					/>
				</div>
				<div style="flex: 3" class="align-self-center">
					<div class="body-1 text-md-h4 font-weight-bold">
						CERTIFICADO DE SERVICIOS
					</div>
				</div>
				<div style="flex: 1" class="bl">
					<div class="mt-md-5 font-weight-medium body-1 text-md-h5">
						Resolucion Sanitaria
					</div>
					<div class="font-weight-medium text-md-body-1 font-weight-bold">
						Nº 7776-10-2019
					</div>
					<div class="font-weight-medium text-md-body-1 font-weight-bold">ISO 9001</div>
				</div>
			</div>
			<div class="text-left bb d-flex justify-space-between align-center">
				<div>
					<div class="body-2">
						REPRESENTANTE LEGAL: Luis Hernán Salazar Zuazo / RUT: 10.511.968-2
					</div>
					<div class="body-2">Calle Santa Lucia Nº 103 - Graneros</div>
					<div class="body-2">TELÉFONOS: +56 9 9638 3844</div>
				</div>
				<div v-if="order && order.id" class="title font-weight-bold">
					№ S/D {{ order.id }}
				</div>
			</div>
			<div class="d-md-flex mt-md-2">
				<div style="flex: 1" class="bb d-md-flex align-md-center text-left">
					<div style="width: 70px" class="text-uppercase text-md-body-1 mr-2">
						Fecha
					</div>
					<input v-model="order.data[0]" style="width: 100%" type="date" />
				</div>
				<div style="flex: 1" class="bb d-md-flex align-md-center text-left">
					<div style="width: 200px" class="text-uppercase text-md-body-1 mr-2">
						HORA INICIO:
					</div>
					<input v-model="order.startHour" style="width: 100%" type="time" />
				</div>
				<div style="flex: 1" class="bb d-md-flex flex-no-wrap align-md-center text-left">
					<div style="width: 250px" class="text-uppercase text-md-body-1 mr-2">
						HORA TERMINO:
					</div>
					<input v-model="order.endHour" style="width: 100%" type="time" />
				</div>
			</div>
			<div class="d-md-flex align-center text-left mt-2">
				<div style="flex: 1" class="d-md-flex align-center">
					<label for="programados">
						SERVICIOS PROGRAMADOS
					</label>
					<input
						id="programados"
						class="ml-2"
						v-model="order.data[3]"
						style="width: 15px"
						type="checkbox"
					/>
				</div>
				<div style="flex: 1" class="d-md-flex align-center">
					<label for="extras">
						SERVICIOS EXTRAS
					</label>
					<input
						id="extras"
						class="ml-2"
						v-model="order.data[4]"
						style="width: 15px"
						type="checkbox"
					/>
				</div>
				<div style="flex: 1" class="d-md-flex align-center">
					<label for="otros">
						OTROS
					</label>
					<input
						id="otros"
						class="ml-2"
						v-model="order.data[5]"
						style="width: 15px"
						type="checkbox"
					/>
				</div>
			</div>
			<div class="d-md-flex mt-2">
				<div style="flex: 1" class="bb d-md-flex flex-no-wrap align-md-center text-left">
					<div style="width: 70px" class="text-uppercase text-md-body-1 mr-2">
						CLIENTE:
					</div>
					<input v-model="order.data[6]" style="width: 100%" type="text" />
				</div>
				<div style="flex: 1" class="bb d-md-flex flex-no-wrap align-md-center text-left">
					<div style="width: 70px" class="text-uppercase text-md-body-1 mr-2">
						PLANTA:
					</div>
					<input v-model="order.data[7]" style="width: 100%" type="text" />
				</div>
			</div>
			<div style="flex: 2" class="bb d-md-flex flex-no-wrap align-md-center text-left">
				<div style="width: 100px" class="text-uppercase text-md-body-1 mr-2">
					Dirección:
				</div>
				<input v-model="order.data[8]" style="width: 100%" type="text" />
			</div>
			<div class="d-md-flex">
				<div style="flex: 2" class="bb d-md-flex flex-no-wrap align-md-center text-left">
					<div style="width: 280px" class="text-uppercase text-md-body-1 mr-2">
						Nombre solicitante:
					</div>
					<input v-model="order.data[9]" style="width: 100%" type="text" />
				</div>
				<div style="flex: 2" class="bb d-md-flex flex-no-wrap align-md-center text-left">
					<div style="width: 230px" class="text-uppercase text-md-body-1 mr-2">
						RUT solicitante:
					</div>
					<input v-model="order.data[10]" style="width: 100%" type="text" />
				</div>
			</div>
			<div style="flex: 2" class="bb d-md-flex flex-no-wrap align-md-center text-left">
				<div style="width: 230px" class="text-uppercase text-md-body-1 mr-2">
					Responsable planta:
				</div>
				<input v-model="order.data[11]" style="width: 100%" type="text" />
			</div>
			<div style="flex: 2" class="bb d-md-flex flex-no-wrap align-md-center text-left">
				<div style="width: 450px" class="text-uppercase text-md-body-1 mr-2">
					Tecnico responsable del trabajo:
				</div>
				<input v-model="order.data[12]" style="width: 100%" type="text" />
			</div>
			<div class="title my-2 bb">
				SERVICIOS REALIZADOS
			</div>
			<div class="d-md-flex align-start">
				<div style="flex: 1">
					<div class="d-flex align-center justify-center justify-md-start">
						<label for="sanitizacion">
							<span class="mr-2 font-italic body-1 text-uppercase">
								SANITIZACIÓN
							</span>
						</label>
						<input
							id="sanitizacion"
							@change="e => (order.sanitizacion = e.target.value)"
							:value="order.sanitizacion"
							type="checkbox"
							style="width: 15px"
						/>
					</div>
					<div class="text-left d-flex flex-wrap">
						<div style="width: 100%" class="text-left mt-3 mb-2">
							<span style="font-size:16px; font-weight:bold;">
								Areas Tratadas (desinfectadas)
							</span>
						</div>
						<label for="data113" style="width: 60%">BANOS</label>
						<div style="width: 25%">
							<input
								id="data113"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[113]"
							/>
						</div>
						<label for="data13" style="width: 60%">BANOS DE SERVICIOS</label>
						<div style="width: 25%">
							<input
								id="data13"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[13]"
							/>
						</div>
						<label for="data14" style="width: 60%">BANOS ADMINISTRATIVOS</label>
						<div style="width: 25%">
							<input
								id="data14"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[14]"
							/>
						</div>
						<label for="data15" style="width: 60%">CAMARINES</label>
						<div style="width: 25%">
							<input
								id="data15"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[15]"
							/>
						</div>
						<label for="data16" style="width: 60%">DUCHAS</label>
						<div style="width: 25%">
							<input
								id="data16"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[16]"
							/>
						</div>
						<label for="data17" style="width: 60%">CASINO</label>
						<div style="width: 25%">
							<input
								id="data17"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[17]"
							/>
						</div>
						<label for="data18" style="width: 60%">BODEGA</label>
						<div style="width: 25%">
							<input
								id="data18"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[18]"
							/>
						</div>
						<label for="data19" style="width: 60%">PRE FRIOS</label>
						<div style="width: 25%">
							<input
								id="data19"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[19]"
							/>
						</div>
						<label for="data20" style="width: 60%">CAMARAS</label>
						<div style="width: 25%">
							<input
								id="data20"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[20]"
							/>
						</div>
						<label for="111" style="width: 60%">OFICINAS</label>
						<div style="width: 25%">
							<input
								id="data111"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[111]"
							/>
						</div>
						<label for="data115" style="width: 60%">PATIO (exterior)</label>
						<div style="width: 25%">
							<input
								id="data115"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[115]"
							/>
						</div>
						<div class="bb" style="width: 65%">
							<label for="data21">OTROS</label>
							<input
								id="data21"
								type="text"
								style="width: 75%"
								v-model="order.data[21]"
							/>
						</div>
					</div>
				</div>
				<div style="flex: 1">
					<div
						class="mt-4 mt-md-0 d-md-flex align-center text-left text-md-body-1 text-uppercase"
					>
						Productos Utilizados
					</div>
					<div class="text-left d-flex flex-wrap">
						<!-- #1 -->
						<input
							id="sani1"
							type="checkbox"
							style="width: 15px;"
							v-model="itemsSanitizacion[0]"
						/>
						<label
							for="sani1"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>SANICITREX</b> / SANITIZANTE NATURAL A BASES DE CITRICOS /
							<br />
							ISP: D-19/23
							<br />Dosis: 80 CC/ 10 Litro de agua
						</label>
						<!-- #2 -->
						<input
							id="sani2"
							type="checkbox"
							style="width: 15px;"
							v-model="itemsSanitizacion[1]"
						/>
						<label
							for="sani2"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>DRAYCUAT PLUS</b> / SALES DE AMONIO CUATERNARIO DE V GENERACION AL
							15%
							<br />
							ISP: D-204/21 <br />Dosis: 90 A 100 CC X 10 LITROS AGUA - SANITIZACION
							SEVERAS
						</label>
						<!-- #3 -->
						<input
							id="sani3"
							type="checkbox"
							style="width: 15px;"
							v-model="itemsSanitizacion[3]"
						/>
						<label
							for="sani3"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>Dryquat 250 SL</b> / Cloruro de Benzalconio 2,5%
							<br />
							ISP: D-204/16 <br />Dosis: 30 cc/Litros de agua
						</label>
						<!-- #4 -->
						<input
							id="sani4"
							type="checkbox"
							style="width: 15px;"
							v-model="itemsSanitizacion[4]"
						/>
						<label
							for="sani4"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>Decutec</b> / Amonio cuaternario 1% - Nano Particulas Cobre 0,2%
							<br />
							ISP: D-1039/20 <br />Dosis: 15 CC/ Metro Cuadrado
						</label>
						<!-- #5 -->
						<input
							id="sani5"
							type="checkbox"
							style="width: 15px;"
							v-model="itemsSanitizacion[5]"
						/>
						<label
							for="sani5"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>Cupex</b> / Etanol 70 % - Nano Cobre 1000 ppm
							<br />
							ISP: <br />Dosis: 15 CC/ Metro Cuadrado
						</label>
						<!-- #6 -->
						<input
							id="sani6"
							type="checkbox"
							style="width: 15px;"
							v-model="itemsSanitizacion[6]"
						/>
						<label
							for="sani6"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>Dryquat 250 SL</b> / Cloruro de Benzalconio 2,5%
							<br />
							ISP: D-204/16<br />Dosis: 5 cc/Litros de agua
						</label>
					</div>
					<div class="text-left">
						<div class="my-1 bb text-uppercase">
							<span style="font-size:12px; font-weight:bold;">Otro producto:</span>
						</div>
						<div class="mb-1 pl-2 bb">
							<span>Nombre</span>
							<input style="width: 90%" v-model="itemsSanitizacion[2].nombre" />
						</div>
						<div class="mb-1 pl-2 bb">
							<span>Detalle</span>
							<input style="width: 90%" v-model="itemsSanitizacion[2].detalle" />
						</div>
						<div class="mb-1 pl-2 bb">
							<span>ISP</span>
							<input style="width: 90%" v-model="itemsSanitizacion[2].isp" />
						</div>
						<div class="mb-1 pl-2 bb">
							<span>Dosis</span>
							<input style="width: 90%" v-model="itemsSanitizacion[2].dosis" />
						</div>
					</div>
				</div>
			</div>
			<div class="bb">
				<div class="text-left">
					<div class="text-uppercase text-md-body-1">Observaciones:</div>
					<textarea
						v-model="order.data[23]"
						rows="5"
						style="width: 100%; background-color: gray;"
						type="text"
					/>
				</div>
			</div>
			<div class="d-md-flex align-start mt-1">
				<div style="flex: 1">
					<div class="d-flex align-center justify-center justify-md-start">
						<label for="desinsectacion">
							<span class="mr-2 font-italic body-1 text-uppercase">
								DESINSECTACIÓN
							</span>
						</label>
						<input
							id="desinsectacion"
							@change="e => (order.desinsectacion = e.target.value)"
							:value="order.desinsectacion"
							type="checkbox"
							style="width: 15px"
						/>
					</div>
					<div class="text-left">
						<span style="font-size:16px; font-weight:bold;">Areas Tratadas</span>
					</div>
					<div class="text-left d-flex flex-wrap mt-3">
						<label for="data24" style="width: 60%">BODEGAS</label>
						<div style="width: 25%">
							<input
								id="data24"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[24]"
							/>
						</div>
						<label for="data25" style="width: 60%">CAMARAS</label>
						<div style="width: 25%">
							<input
								id="data25"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[25]"
							/>
						</div>
						<label for="data26" style="width: 60%">PATIO(exterior)</label>
						<div style="width: 25%">
							<input
								id="data26"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[26]"
							/>
						</div>
						<label for="data116" style="width: 60%">OFICINAS</label>
						<div style="width: 25%">
							<input
								id="data116"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[116]"
							/>
						</div>
						<label for="data117" style="width: 60%">CASINO</label>
						<div style="width: 25%">
							<input
								id="data117"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[117]"
							/>
						</div>
						<label for="data118" style="width: 60%">BANOS</label>
						<div style="width: 25%">
							<input
								id="data118"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[118]"
							/>
						</div>
						<label for="data122" style="width: 60%">BANOS DE SERVICIOS</label>
						<div style="width: 25%">
							<input
								id="data122"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[122]"
							/>
						</div>
						<label for="data123" style="width: 60%">BANOS ADMINISTRATIVOS</label>
						<div style="width: 25%">
							<input
								id="data123"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[123]"
							/>
						</div>
						<label for="data124" style="width: 60%">CAMARINES</label>
						<div style="width: 25%">
							<input
								id="data124"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[124]"
							/>
						</div>
						<label for="data125" style="width: 60%">DUCHAS</label>
						<div style="width: 25%">
							<input
								id="data125"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[125]"
							/>
						</div>
						<label for="data126" style="width: 60%">PRE FRIOS</label>
						<div style="width: 25%">
							<input
								id="data126"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[126]"
							/>
						</div>
						<div class="bb" style="width: 65%">
							<label for="data27">OTROS</label>
							<input
								id="data27"
								type="text"
								style="width: 75%"
								v-model="order.data[27]"
							/>
						</div>
					</div>
				</div>
				<div style="flex: 1">
					<div
						class="mt-3 mt-md-0 d-md-flex align-center text-left text-md-body-1 text-uppercase"
					>
						Productos Utilizados
					</div>
					<div class=" text-left d-flex">
						<input
							type="checkbox"
							id="des0"
							style="width: 15px"
							v-model="itemsDesinsectacion[0]"
						/>
						<label for="des0" style="width: 95%;" class="text-left mb-2">
							<div style="width: 80%; padding-left:10px;">
								<b>Cyperkill plus </b> Cipermetrina 25,0% critico desinfectante 10g/
								Transtertrametrina 15% EC Registro ISP: P-407/1 / Dosis 20-25 cc x 5
								lts agua de agua
							</div>
						</label>
					</div>
					<div class="text-left d-md-flex">
						<input
							id="des1"
							type="checkbox"
							style="width: 15px"
							v-model="itemsDesinsectacion[1]"
						/>
						<label for="des1" style="width: 95%; padding-left:10px;">
							<b>Actellic 50 EC </b> Pirlmifos.metil al 50% / Registro ISP: P-0027/98
						</label>
					</div>
					<div class="  text-left d-md-flex">
						<input
							id="des3"
							type="checkbox"
							style="width: 15px"
							v-model="itemsDesinsectacion[3]"
						/>
						<label for="des3" style="width: 95%; padding-left:10px;">
							<b>Temprid sc </b> Imidacloprid 21%p/p + betaciflutrina 10,5% pp /
							Registro ISP: P-715/14 / Dosis 2-4 cc/lts de agua
						</label>
					</div>
					<div class="  text-left d-md-flex">
						<input
							id="des4"
							type="checkbox"
							style="width: 15px"
							v-model="itemsDesinsectacion[4]"
						/>
						<label for="des4" style="width: 95%; padding-left:10px;">
							<b>Demand sc</b> Lamda cihalotrina 2,5 g / Registro ISP: P-674/19 /
							Dosis 10 cc/ lts de agua
						</label>
					</div>
					<div class="  text-left d-md-flex">
						<input
							id="des5"
							type="checkbox"
							style="width: 15px"
							v-model="itemsDesinsectacion[5]"
						/>
						<label for="des5" style="width: 95%; padding-left:10px;">
							<b>Blattanex </b> Imidacloprida 2,15%p/p / Registro ISP: P-670/18 /
							Dosis 2 gotas por mts 2
						</label>
					</div>
					<div class="  text-left d-md-flex">
						<input
							id="des6"
							type="checkbox"
							style="width: 15px"
							v-model="itemsDesinsectacion[6]"
						/>
						<label for="des6" style="width: 95%; padding-left:10px;">
							<b>Cyperkill 25 EC</b> Cipermetrina 25% EC / Registro ISP: P-101/19 /
							Dosis 8cc/lts de agua
						</label>
					</div>
					<div class="  text-left d-md-flex">
						<input
							id="des7"
							type="checkbox"
							style="width: 15px"
							v-model="itemsDesinsectacion[7]"
						/>
						<label for="des7" style="width: 95%; padding-left:10px;">
							<b>Bell </b> Imidacloprid 2,15%p/p / Registro ISP: P-670/18 / Dosis 2
							gotas por mts 2
						</label>
					</div>
					<div class="  text-left d-md-flex">
						<input
							id="des8"
							type="checkbox"
							style="width: 15px"
							v-model="itemsDesinsectacion[8]"
						/>
						<label for="des8" style="width: 95%; padding-left:10px;">
							<b>Advion </b> Indoxacarb 0,6 grs / Registro ISP: P-800/17 / Dosis 3
							gotas cada 3 mt s lineales
						</label>
					</div>
					<div class="text-left">
						<div class="my-1 bb text-uppercase">
							<span style="font-size:12px; font-weight:bold;">Otro producto:</span>
						</div>
						<div class="mb-1 pl-2 bb">
							<span>Nombre</span>
							<input style="width: 90%" v-model="itemsDesinsectacion[2].nombre" />
						</div>
						<div class="mb-1 pl-2 bb">
							<span>Detalle</span>
							<input style="width: 90%" v-model="itemsDesinsectacion[2].detalle" />
						</div>
						<div class="mb-1 pl-2 bb">
							<span>ISP</span>
							<input style="width: 90%" v-model="itemsDesinsectacion[2].isp" />
						</div>
						<div class="mb-1 pl-2 bb">
							<span>Dosis</span>
							<input style="width: 90%" v-model="itemsDesinsectacion[2].dosis" />
						</div>
					</div>
				</div>
			</div>
			<div class="mt-2 text-left font-weight-bold text-md-body-1">
				EQUIPOS LUZ ULTRAVIOLETA
			</div>
			<v-row class="mt-2">
				<v-col cols="12" md="5" xl="4" class="text-left">
					<v-row class="mb-1" no-gutters>
						<v-col cols="8" md="9">
							<span>NUMERO DE EQUIPOS UV INSTALADOS</span>
						</v-col>
						<v-col cols="4" md="3">
							<input
								class="ba"
								style="height:20px; width: 100%"
								v-model="order.data[29]"
							/>
						</v-col>
					</v-row>
					<v-row class="mb-1" no-gutters>
						<v-col cols="8" md="9">
							<span>NUMERO DE EQUIPOS UV FUNCIONANDOS</span>
						</v-col>
						<v-col cols="4" md="3">
							<input
								class="ba"
								style="height:20px; width: 100%"
								v-model="order.data[31]"
							/>
						</v-col>
					</v-row>
					<v-row class="mb-1" no-gutters>
						<v-col cols="8" md="9">
							<span>NUMERO DE EQUIPOS UV DEFECTUOSOS</span>
						</v-col>
						<v-col cols="4" md="3">
							<input
								class="ba"
								style="height:20px; width: 100%"
								v-model="order.data[33]"
							/>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="12" md="5" xl="4" class="text-left">
					<v-row class="mb-1" no-gutters>
						<v-col order="2" order-md="1" cols="4" md="3" class="pr-md-2">
							<input
								class="ba"
								style="height:20px; width: 100%"
								v-model="order.data[30]"
							/>
						</v-col>
						<v-col order="1" order-md="2" cols="8" md="9">
							<span>LIMPIEZA DE EQUIPOS</span>
						</v-col>
					</v-row>
					<v-row class="mb-1" no-gutters>
						<v-col order="2" order-md="1" cols="4" md="3" class="pr-md-2">
							<input
								class="ba"
								style="height:20px; width: 100%"
								v-model="order.data[32]"
							/>
						</v-col>
						<v-col order="1" order-md="2" cols="8" md="9">
							<span>CAMBIO DE LAMINA PEGAJOSA</span>
						</v-col>
					</v-row>
					<v-row class="mb-1" no-gutters>
						<v-col order="2" order-md="1" cols="4" md="3" class="pr-md-2">
							<input
								class="ba"
								style="height:20px; width: 100%"
								v-model="order.data[34]"
							/>
						</v-col>
						<v-col order="1" order-md="2" cols="8" md="9">
							<span>CAMBIO DE TUBO UV</span>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<div class="bb mt-2">
				<div class="text-left">
					<div class="text-uppercase text-md-body-1">Observaciones:</div>
					<textarea v-model="order.data[35]" rows="3" style="width: 100%" type="text" />
				</div>
			</div>
			<div class="mt-10 d-sm-flex justify-space-between overflow-x-auto">
				<div>
					<template v-if="getUser.role === 'person' || query.edicion">
						<div class="bb text-left">
							<span style="width: 30%" class="text-uppercase text-md-body-1">
								Cliente:
							</span>
							<input v-model="order.cliente.nombre" style="width: 70%" type="text" />
						</div>
						<div class="bb text-left">
							<span style="width: 30%" class="text-uppercase text-md-body-1">
								RUT:
							</span>
							<input v-model="order.cliente.rut" style="width: 70%" type="text" />
						</div>
					</template>
					<div v-else class="bb text-left">
						<span style="width: 30%" class="text-uppercase body-1">
							Cliente:
						</span>
						<span class="body-2 text-capitalize">
							{{ order.cliente.nombre }} {{ order.cliente.rut }}
						</span>
					</div>
					<canvas-draw
						id="cliente"
						v-if="getUser.role === 'person'"
						class="mt-2"
						type="cliente"
					></canvas-draw>
					<template v-if="query.edicion && !getLoading">
						<v-switch
							class="ml-3"
							v-model="editarFirma"
							:label="editarFirma ? 'Ver firma cliente' : 'Editar firma cliente'"
						></v-switch>
						<canvas-draw
							id="cliente"
							v-if="editarFirma"
							class="mt-2"
							type="cliente"
						></canvas-draw>
						<v-img v-else height="200" eager contain :src="order.firma" alt="firma" />
					</template>
					<v-img
						v-if="!query.edicion && getUser.role !== 'person'"
						height="200"
						eager
						contain
						:src="order.firma"
						alt="firma"
					/>
					<span style="font-size: 19px">www.lusazu.cl</span>
				</div>
				<div>
					<template v-if="getUser.role === 'person' || query.edicion">
						<div class="bb text-left">
							<span style="width: 30%" class="text-uppercase text-md-body-1">
								Tecnico:
							</span>
							<input
								v-model="order.datosTecnico.nombre"
								style="width: 70%"
								type="text"
							/>
						</div>
						<div class="bb text-left">
							<span style="width: 30%" class="text-uppercase text-md-body-1">
								RUT:
							</span>
							<input
								v-model="order.datosTecnico.rut"
								style="width: 70%"
								type="text"
							/>
						</div>
					</template>
					<div v-else class="bb text-left">
						<span style="width: 30%" class="text-uppercase body-1">
							Tecnico:
						</span>
						<span class="body-2 text-capitalize">
							{{ order.datosTecnico.nombre }} {{ order.datosTecnico.rut }}
						</span>
					</div>
					<canvas-draw
						id="tecnico"
						v-if="getUser.role === 'person'"
						class="mt-2"
						type="tecnico"
					></canvas-draw>
					<template v-if="query.edicion && !getLoading">
						<v-switch
							class="ml-3"
							v-model="editarFirmaTecnico"
							:label="
								editarFirmaTecnico ? 'Ver firma tecnico' : 'Editar firma tecnico'
							"
						></v-switch>
						<canvas-draw
							id="tecnico"
							v-if="editarFirmaTecnico"
							class="mt-2"
							type="tecnico"
						></canvas-draw>
						<v-img
							v-else
							height="200"
							eager
							contain
							:src="order.firmaTecnico"
							alt="firma"
						/>
					</template>
					<v-img
						v-if="!query.edicion && getUser.role !== 'person'"
						height="200"
						eager
						contain
						:src="order.firmaTecnico"
						alt="firma"
					/>
					<span style="font-size: 19px">info@lusazu.cl</span>
				</div>
			</div>
			<!-- End Form -->
			<div class="page-break"></div>
			<v-col v-if="images.length" cols="12">Antecedentes fotográficos:</v-col>
			<div style="width: 100%">
				<div class="d-md-flex flex-wrap" v-if="images.length">
					<div v-for="(img, key) in images" :key="key">
						<a target="_blank" :href="img.url">
							<v-img
								:src="img.url"
								class="mr-1 foto-antecedentes"
								alt="imagen de la orden"
							>
								<div class="bg caption text-right">{{ createAt(img._id) }}</div>
							</v-img>
						</a>
					</div>
				</div>
			</div>
			<div v-if="getUser.role === 'person'" class="d-flex justify-center">
				<v-checkbox
					dense
					v-model="order.correo"
					:value="lodgingSelect.place.email[0]"
					:label="`¿Desea enviar email a ${lodgingSelect.place.email[0]}?`"
				>
				</v-checkbox>
			</div>
			<div class="my-6">
				<v-btn
					:loading="loading"
					class="mx-2"
					outlined
					color="#7a972c"
					@click="onSubmit"
					v-if="getUser.role === 'person'"
				>
					Guardar
				</v-btn>
				<div v-else>
					<v-btn
						:loading="editLoading"
						class="mx-2"
						outlined
						color="#7a972c"
						@click="editarOT"
						:disabled="!lodgingSelect"
						v-if="query.edicion"
					>
						EDITAR ESTA ORDEN
					</v-btn>
					<v-btn
						:loading="loading"
						class="mx-2"
						outlined
						color="#7a972c"
						@click="sendCertify"
						v-else
					>
						Certificar
					</v-btn>
				</div>
			</div>
		</v-container>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { setUserWithToken } from '@/plugins/auth';
import recommendations from '../../../assets/lusazu/recommendations.json';
import moment from 'moment';

export default {
	components: {
		CanvasDraw: () => import('@/components/ui/CanvasDraw'),
	},
	data() {
		return {
			editLoading: false,
			editarFirma: false,
			editarFirmaTecnico: false,
			especies: [
				'ROEDORES',
				'CUCARACHAS',
				'TERMITAS',
				'MOSCA',
				'ZANCUDOS',
				'PULGAS',
				'GARRAPATAS',
				'ARAÑAS',
				'HORMIGAS',
				'CHINCHES',
				'TIJERETAS',
			],
			loading: false,
			getLoading: false,
			showSurvey: false,
			answers: null,
			query: null,
			params: null,
			services: [
				'Sanitizado',
				'Desratizado',
				'Desinsectado',
				'Sanitizado/Desratizado',
				'Sanitizado/Desinsectado',
				'Desratizado/Desinsectado',
				'Sanitizado/Desratizado/Desinsectado',
			],
			image: null,
			order: {
				date: undefined,
				data: [],
				id: undefined,
				user: undefined,
				correo: undefined,
				cliente: { nombre: undefined, rut: undefined },
				datosTecnico: { nombre: undefined, rut: undefined },
				imagen: { date: undefined, image: undefined },
				type: 'lusazu',
				firma: '',
				firmaTecnico: '',
				tecnico: '',
				endHour: '',
				startHour: '',
				vigencia: '',
				reco2: '',
				reco3: '',
				recosType: [],
				sanitizacion: false,
				desinsectacion: false,
				desratizado: false,
				itemsTrampas: [],
			},
			itemsDesinsectacion: [false, false, { nombre: '', dosis: '', detalle: '', isp: '' }],
			itemsDesratizacion: [],
			itemsSanitizacion: [false, false, { nombre: '', dosis: '', detalle: '', isp: '' }],
			images: [],
			itemsTrampas: [
				[
					{
						tipo: '',
						numero: '',
						observacion: '',
					},
				],
				[
					{
						tipo: '',
						numero: '',
						observacion: '',
					},
				],
				[
					{
						tipo: '',
						numero: '',
						observacion: '',
					},
				],
			],
			recommendations,
		};
	},
	computed: {
		...mapGetters({
			lodgingSelect: 'Lodging/lodgingSelect',
			getUser: 'User/profile',
			person: 'Person/person',
			firmaString: 'Lodging/firma',
			firmaTecnicoString: 'Lodging/firmaTecnico',
		}),
	},
	created() {
		this.query = this.$route.query;
		this.params = this.$route.params;
	},
	async mounted() {
		if (this.query.bearerToken) {
			await setUserWithToken({ token: this.query.bearerToken });
			await this.fetchInit();
		} else if ((this.query.idLodging || this.params.idLodging) && !this.lodgingSelect)
			await this.fetchInit();
		this.lodgingId = this.$route.params.idLodging;
		this.indexWorkOrder = this.$route.params.index;
		if (this.lodgingId) {
			this.getLoading = true;
			this.getWorkOrder({
				idLodging: this.lodgingId,
				indexWorkOrder: this.indexWorkOrder,
			}).then(data => {
				this.order = data.workOrder;
				this.itemsSanitizacion = this.order.data[22];
				this.itemsDesinsectacion = this.order.data[28];
				this.itemsDesratizacion = this.order.data[39];
				this.itemsTrampas = this.order.data[40];
				this.place = data.place;
				this.images = data.documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
				this.getLoading = false;
			});
		}
		if (this.lodgingSelect && !this.lodgingId) {
			this.setValuesDefault();
			this.lodgingId = this.lodgingSelect._id;
		}
	},
	methods: {
		addTrampa(index) {
			this.itemsTrampas[index].push({
				tipo: '',
				numero: '',
				observacion: '',
			});
		},
		removeTrampa(index) {
			this.itemsTrampas[index].pop();
		},
		validateImage(typeDocument) {
			typeDocument = typeDocument.toLowerCase();
			if (typeDocument === 'jpg' || typeDocument === 'png' || typeDocument === 'peg')
				return true;
			return false;
		},
		createAt(id) {
			const date = new Date(parseInt(id.substring(0, 8), 16) * 1000);
			if (date) return moment(date).format('lll');
			else return 'Sin fecha';
		},

		async fetchInit() {
			try {
				await this.getLodging(this.query.idLodging || this.params.idLodging);
				this.setPerson(this.lodgingSelect.person);
			} catch (error) {
				this.$router.push('/guest/timeline');
			}
		},
		async onSubmit() {
			this.loading = true;
			this.order.firma = this.firmaString;
			this.order.firmaTecnico = this.firmaTecnicoString;
			this.order.data[22] = this.itemsSanitizacion;
			this.order.data[28] = this.itemsDesinsectacion;
			this.order.data[39] = this.itemsDesratizacion;
			this.order.data[40] = [...this.itemsTrampas];
			const data = JSON.stringify(this.order);
			const payload = new FormData();
			payload.append('image', this.image);
			payload.append('order', data);
			await this.createWorkOrder({
				idLodging: this.lodgingSelect._id,
				payload,
			});
			this.image = null;
			this.setFirma('');
			this.loading = false;
			this.setLodgingSelect(null);
			this.$router.push('/guest/timeline');
		},
		async sendCertify() {
			this.loading = true;
			this.order.data[22] = this.itemsSanitizacion;
			this.order.data[28] = this.itemsDesinsectacion;
			this.order.data[39] = this.itemsDesratizacion;
			this.order.data[40] = this.itemsTrampas;
			this.order.type = 'lusazu-certificate';
			const data = JSON.stringify(this.order);
			const payload = new FormData();
			payload.append('image', this.image);
			payload.append('order', data);
			await this.certifyWorkOrder({
				idLodging: this.lodgingId,
				indexWorkOrder: this.indexWorkOrder,
				payload,
			});
			this.image = null;
			this.loading = false;
			this.fetchPlace();
			this.$router.push({ name: 'places' });
		},
		async editarOT() {
			this.editLoading = true;
			this.order.data[22] = this.itemsSanitizacion;
			this.order.data[28] = this.itemsDesinsectacion;
			this.order.data[39] = this.itemsDesratizacion;
			this.order.data[40] = this.itemsTrampas;
			this.order.firma = this.editarFirma ? this.firmaString : this.order.firma;
			this.order.firmaTecnico = this.editarFirmaTecnico
				? this.firmaTecnicoString
				: this.order.firmaTecnico;
			const payload = {
				lodging: this.lodgingId,
				index: this.indexWorkOrder,
				workOrder: this.order,
			};
			this.order = await this.atualizarOT(payload);
			this.editarFirma = false;
			this.editarFirmaTecnico = false;
			this.editLoading = false;
		},
		setValuesDefault() {
			for (var i = 0; i <= 126; i++) {
				this.order.data.push(null);
			}
			if (this.lodgingSelect.histories) {
				const todayHistory = this.filterTodayHistory(this.lodgingSelect.histories);
				this.order.startHour = todayHistory ? moment(todayHistory.in).format('HH:mm') : '';
			}
			this.order.data[0] = this.lodgingSelect.start;
			this.order.data[1] = this.lodgingSelect.group;
			this.order.data[6] = this.lodgingSelect.place.cliente;
			this.order.data[23] = '';
			this.order.data[35] = '';
			this.order.data[50] = '';
			this.recommendations.Sanitizacion.forEach(item => {
				this.order.data[23] += item + '\n';
			});
			this.recommendations.Desinsectacion.forEach(item => {
				this.order.data[35] += item + '\n';
			});
			this.recommendations.Desratizacion.forEach(item => {
				this.order.data[50] += item + '\n';
			});
			// this.order.data[6] = this.lodgingSelect.place.direction;
			this.order.data[7] = this.lodgingSelect.place.name;
			this.order.data[8] = this.lodgingSelect.place.direction;
			this.order.data[9] = this.lodgingSelect.place.nombreSolicitante;
			this.order.data[10] = this.lodgingSelect.place.rutSolicitante;
			// this.order.data[11] = this.lodgingSelect.place.direccionSolicitante;
			this.order.data[12] = `${this.lodgingSelect.person.firstName.toUpperCase()} ${
				this.lodgingSelect.person.lastName
					? this.lodgingSelect.person.lastName.toUpperCase()
					: ''
			}`;
			this.order.date = moment().format('DD/MM/YY');
			this.order.endHour = moment().format('HH:mm');
		},
		filterTodayHistory(histories) {
			return histories.find(history => {
				const checkIn = moment(history.in);
				const today = moment();
				if (today.isSame(checkIn, 'day')) return history;
			});
		},
		...mapMutations({
			setLodgingSelect: 'Lodging/setLodgingSelect',
			setPerson: 'Person/setPerson',
			setFirma: 'Lodging/setFirma',
			setFirmaTecnico: 'Lodging/setFirmaTecnico',
		}),
		...mapActions({
			atualizarOT: 'Lodging/atualizarOT',
			createWorkOrder: 'Lodging/createWorkOrder',
			certifyWorkOrder: 'Lodging/certifyWorkOrder',
			updateLodging: 'Lodging/updateLodging',
			getLodging: 'Lodging/getLodging',
			getWorkOrder: 'Lodging/getWorkOrder',
			fetchPlace: 'Lodging/fetchPlace',
		}),
	},
};
</script>

<style scoped>
input {
	height: 18px;
	border: 1px solid gray;
	background-color: #a2850721;
}
.nw {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.marca-agua {
	position: absolute;
	top: 40%;
	left: 30%;
	opacity: 0.1;
	z-index: 1;
}
* {
	color: black;
	-webkit-print-color-adjust: exact !important;
	color-adjust: exact !important;
	font-size: 12px;
}
/* Tamaño pagina 1056 1392 px  */
@media print {
	@page {
		size: A3 portrait;
		width: 100%;
		margin: auto;
	}
	.firmas {
		max-height: 90px !important;
		height: 90px !important;
	}
	.antecedentes-fotograficos {
		display: none;
	}
	.border-ot {
		display: table;
		margin: 0 auto;
		border: 0px !important;
	}
	.page-break {
		display: block;
		page-break-before: always;
	}
}
.border-a {
	border-bottom: 2px solid gray !important ;
	margin-bottom: 2px;
	width: 98%;
	max-width: 1050px;
	height: 1300px;
}
.ba {
	border: 1px solid black;
}
.bl {
	border-left: 1px solid black;
}
.br {
	border-right: 1px solid black;
}
.bt {
	border-top: 1px solid black;
}
.bb {
	border-bottom: 1px solid black;
}
.bg {
	background-color: #80bd00;
	color: white;
}
.bg-secondary {
	background-color: #f6c90071;
}
.cc {
	width: 30px;
	height: 15px;
}
.border-ot {
	background-color: white;
	margin: 5px auto;
	width: 100%;
	max-width: 1050px;
}
.foto-antecedentes {
	border-radius: 15px;
	margin-bottom: 50px;
	height: 200px;
	width: 200px;
	border: 1px solid black;
}

.text--color {
	color: rgba(255, 255, 255, 0.74);
}

input {
	border: none;
	font-size: 16px;
	background-color: #ffffff;
	outline: none;
	padding: 0 5px;
}
select {
	border: none;
	background-color: #ffffff;
	outline: none;
	padding: 0 5px;
}
textarea {
	font-size: 18px;
	outline: none;
}
@media (max-width: 800px) {
	input {
		font-size: 14px;
	}
}
</style>
